(function(){
  var cqLwmScript=document.currentScript;
  function run(){
  if(!window.L||!window.leadData){return;}
  function sanitize(s){if(s===0)return'0';if(!s)return'';return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;').replace(/'/g,'&#039;');}

  /* GA4 dataLayer events (the live hardness section has no analytics; added here) */
  function track(ev,params){try{window.dataLayer=window.dataLayer||[];var p={event:ev,tool_key:'lead'};for(var k in params){p[k]=params[k];}window.dataLayer.push(p);}catch(e){}}

  var map=L.map('cq-lwm-map',{preferCanvas:true,renderer:L.canvas({tolerance:8})}).setView([39.8283,-98.5795],4);
  L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',{maxZoom:18,attribution:'© OpenStreetMap'}).addTo(map);

  var statesLayer,stateLayersByCode={};
  var stateNames={'AL':'Alabama','AK':'Alaska','AZ':'Arizona','AR':'Arkansas','CA':'California','CO':'Colorado','CT':'Connecticut','DE':'Delaware','DC':'District of Columbia','FL':'Florida','GA':'Georgia','HI':'Hawaii','ID':'Idaho','IL':'Illinois','IN':'Indiana','IA':'Iowa','KS':'Kansas','KY':'Kentucky','LA':'Louisiana','ME':'Maine','MD':'Maryland','MA':'Massachusetts','MI':'Michigan','MN':'Minnesota','MS':'Mississippi','MO':'Missouri','MT':'Montana','NE':'Nebraska','NV':'Nevada','NH':'New Hampshire','NJ':'New Jersey','NM':'New Mexico','NY':'New York','NC':'North Carolina','ND':'North Dakota','OH':'Ohio','OK':'Oklahoma','OR':'Oregon','PA':'Pennsylvania','PR':'Puerto Rico','RI':'Rhode Island','SC':'South Carolina','SD':'South Dakota','TN':'Tennessee','TX':'Texas','UT':'Utah','VT':'Vermont','VA':'Virginia','WA':'Washington','WV':'West Virginia','WI':'Wisconsin','WY':'Wyoming'};
  var nameToCode={};for(var c in stateNames)nameToCode[stateNames[c]]=c;

  /* 5 lead tiers. scale/ink = editorial severity colors taught in the "What
     Your Lead Result Means" section; one scale now colors the utility dots,
     the state-median choropleth, the legend, and the user's own result. */
  var TIERS=[
    {max:0,label:'Non-Detect',cls:'cq-lwm-tier-0',scale:'#10b981',ink:'#047857'},
    {max:5,label:'Trace Detection',cls:'cq-lwm-tier-1',scale:'#84cc16',ink:'#4d7c0f'},
    {max:10,label:'Elevated',cls:'cq-lwm-tier-2',scale:'#f59e0b',ink:'#b45309'},
    {max:15,label:'Exceeds 2027 Level',cls:'cq-lwm-tier-3',scale:'#ef4444',ink:'#dc2626'},
    {max:null,label:'Above Action Level',cls:'cq-lwm-tier-4',scale:'#b91c1c',ink:'#991b1b'}
  ];
  function tierFor(ppb){
    if(ppb<=0)return TIERS[0];
    if(ppb<5)return TIERS[1];
    if(ppb<10)return TIERS[2];
    if(ppb<15)return TIERS[3];
    return TIERS[4];
  }

  /* states: {ST:[n_recent,n_over15,n_over10,median_ppb,pct_nondetect,population,n_total,n_active_cws]} */
  function stateRow(code){return window.leadData.states[code]||null;}
  function getStateColor(stateCode){
    var row=stateRow(stateCode);
    if(!row)return'#e5e7eb';
    return tierFor(row[3]).scale;
  }

  /* Decode compact system records + build the ZIP index.
     Record: [pwsid,name,city,state,population,latest_ppb,latest_period_YYYYMM,max_ppb,max_year,n_periods,[zips...],[lat,lng]|null]
     Index 11 (coords) exists from data version 2; null when no served ZIP
     resolves to a centroid. Always null-check before plotting. */
  function sys(rec){return{pwsid:rec[0],name:rec[1],city:rec[2],state:rec[3],population:rec[4],value:rec[5],period:rec[6],maxPpb:rec[7],maxYear:rec[8],nPeriods:rec[9],zips:rec[10]||[],lat:rec[11]?rec[11][0]:null,lng:rec[11]?rec[11][1]:null};}
  var SYSTEMS=window.leadData.systems.map(sys);
  var ZIP_INDEX={};
  SYSTEMS.forEach(function(s,i){s.zips.forEach(function(z){(ZIP_INDEX[z]=ZIP_INDEX[z]||[]).push(i);});});
  function zipLookupAll(zip){
    var idx=ZIP_INDEX[zip];
    if(!idx)return[];
    return idx.map(function(i){return SYSTEMS[i];}).sort(function(a,b){return b.population-a.population;});
  }

  /* ZIP 3-digit-prefix -> state (USPS prefix ranges) for the state-aggregate
     fallback when no full system record carries the searched ZIP. */
  var ZIP3=[[5,5,'NY'],[6,9,'PR'],[10,27,'MA'],[28,29,'RI'],[30,38,'NH'],[39,49,'ME'],[50,59,'VT'],[60,69,'CT'],[70,89,'NJ'],[100,149,'NY'],[150,196,'PA'],[197,199,'DE'],[200,205,'DC'],[206,219,'MD'],[220,246,'VA'],[247,268,'WV'],[270,289,'NC'],[290,299,'SC'],[300,319,'GA'],[320,349,'FL'],[350,369,'AL'],[370,385,'TN'],[386,397,'MS'],[398,399,'GA'],[400,427,'KY'],[430,459,'OH'],[460,479,'IN'],[480,499,'MI'],[500,528,'IA'],[530,549,'WI'],[550,567,'MN'],[570,577,'SD'],[580,588,'ND'],[590,599,'MT'],[600,629,'IL'],[630,658,'MO'],[660,679,'KS'],[680,693,'NE'],[700,714,'LA'],[716,729,'AR'],[730,749,'OK'],[750,799,'TX'],[800,816,'CO'],[820,831,'WY'],[832,838,'ID'],[840,847,'UT'],[850,865,'AZ'],[870,884,'NM'],[885,885,'TX'],[889,898,'NV'],[900,966,'CA'],[967,968,'HI'],[970,979,'OR'],[980,994,'WA'],[995,999,'AK']];
  function zipToState(zip){
    var p=parseInt(zip.slice(0,3),10);
    for(var i=0;i<ZIP3.length;i++){if(p>=ZIP3[i][0]&&p<=ZIP3[i][1])return ZIP3[i][2];}
    return null;
  }

  /* Display helpers */
  function displayName(allCaps){
    var t=String(allCaps).toLowerCase().replace(/\b[a-z]/g,function(ch){return ch.toUpperCase();});
    t=t.replace(/\(([^)]+)\)/g,function(m,p){return'('+p.toUpperCase()+')';});
    t=t.replace(/\b(Of|And|The|At|On|For|By)\b/g,function(m){return m.toLowerCase();});
    return t.charAt(0).toUpperCase()+t.slice(1);
  }
  var MONTHS=['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  function fmtPeriod(yyyymm){var s=String(yyyymm);var y=s.slice(0,4),m=parseInt(s.slice(4,6),10);return(MONTHS[m-1]||'')+' '+y;}
  function periodYear(yyyymm){return Math.floor(yyyymm/100);}
  function fmtCompact(n){
    if(n>=1000000)return(Math.round(n/100000)/10)+'M';
    if(n>=1000)return(Math.round(n/100)/10)+'K';
    return String(n);
  }
  function showError(msg){var e=document.getElementById('cqLwmError');e.textContent=msg||'';e.hidden=!msg;}
  function showLoading(){document.getElementById('cqLwmLoading').classList.add('active');}
  function hideLoading(){document.getElementById('cqLwmLoading').classList.remove('active');}

  /* State-median choropleth, default OFF (utility dots are the default view).
     The us-states GeoJSON is self-hosted as the cq-us-states.js theme asset
     (window.cqUsStatesGeo), so there is no runtime third-party fetch. */
  var statesOn=false;
  (window.cqUsStatesGeo?Promise.resolve(window.cqUsStatesGeo):Promise.reject(new Error('cq-us-states.js asset not loaded')))
    .then(function(data){
      function style(f){var sc=nameToCode[f.properties.name];return{fillColor:getStateColor(sc),weight:2,opacity:1,color:'white',fillOpacity:0.45};}
      function hl(e){e.target.setStyle({weight:3,color:'#171796',fillOpacity:0.6});}
      function rs(e){statesLayer.resetStyle(e.target);}
      function zoom(e){
        map.fitBounds(e.target.getBounds());
        var sn=e.target.feature.properties.name,sc=nameToCode[sn],row=stateRow(sc);
        if(row){
          var t=tierFor(row[3]);
          L.popup().setLatLng(e.latlng).setContent('<div class="cq-lwm-popup"><h3>'+sanitize(sn)+'</h3><p>Median reported lead (90th pct):</p><div class="lead-value" style="color:'+t.ink+'">'+sanitize(row[3])+' PPB</div><p style="color:'+t.ink+';font-weight:600">'+sanitize(t.label)+'</p><p style="font-size:12px;color:#9ca3af;margin-top:8px">'+sanitize(row[0].toLocaleString())+' systems reported since 2016 &middot; '+sanitize(row[1])+' above 15 PPB &middot; '+sanitize(row[2])+' above 10 PPB</p></div>').openOn(map);
        }
      }
      statesLayer=L.geoJson(data,{style:style,onEachFeature:function(f,l){var code=nameToCode[f.properties.name];if(code)stateLayersByCode[code]=l;l.on({mouseover:hl,mouseout:rs,click:zoom});}});
      if(statesOn){statesLayer.addTo(map);statesLayer.bringToBack();}
    })
    .catch(function(){/* map stays usable without the choropleth */});

  window.cqLwmToggleStates=function(on){
    statesOn=on;
    if(!statesLayer)return;
    if(on){statesLayer.addTo(map);statesLayer.bringToBack();}
    else{map.removeLayer(statesLayer);}
    track('tool_layer_toggle',{layer:'states',state:on?'on':'off'});
  };

  function zoomToState(code){var l=stateLayersByCode[code];if(l)map.fitBounds(l.getBounds());}

  /* Per-utility dots: canvas circle markers (same scale as the live PFAS map's
     9,728 dots), severity-colored, radius lightly scaled by population served.
     Requires data v2 coords; the layer simply stays empty on older data. */
  var dotsLayer=L.layerGroup(),dotMarkers=[];
  var DATA_V2=window.leadData.meta&&window.leadData.meta.version>=2;
  function dotRadius(pop){return pop>=1000000?7:pop>=100000?6:pop>=10000?5:4;}
  if(DATA_V2){
    SYSTEMS.forEach(function(s,i){
      if(s.lat===null||s.lng===null)return;
      var t=tierFor(s.value),baseR=dotRadius(s.population);
      var cm=L.circleMarker([s.lat,s.lng],{radius:baseR,fillColor:t.scale,color:'#ffffff',weight:1,opacity:1,fillOpacity:0.85,_sIdx:i,_baseR:baseR});
      cm.on('click',function(e){L.DomEvent.stopPropagation(e);openDotPopup(SYSTEMS[e.target.options._sIdx],e.target.getLatLng());});
      dotsLayer.addLayer(cm);
      dotMarkers.push(cm);
    });
    var cEl=document.getElementById('cqLwmDotCount');
    if(cEl)cEl.textContent=(window.leadData.meta.systems_with_coords||dotMarkers.length).toLocaleString();
  }
  dotsLayer.addTo(map);

  function updateDotSize(){
    var z=map.getZoom();
    var scale=z<=4?1:z<=6?1.3:z<=8?1.8:z<=10?2.4:3;
    var w=z<=6?1:z<=10?1.5:2;
    for(var i=0;i<dotMarkers.length;i++){dotMarkers[i].setRadius(dotMarkers[i].options._baseR*scale);dotMarkers[i].setStyle({weight:w});}
  }
  map.on('zoomend',updateDotSize);

  window.cqLwmToggleDots=function(on){
    if(on){dotsLayer.addTo(map);}else{map.removeLayer(dotsLayer);}
    track('tool_layer_toggle',{layer:'dots',state:on?'on':'off'});
  };

  function openDotPopup(s,latlng){
    var t=tierFor(s.value);
    L.popup().setLatLng(latlng).setContent(
      '<div class="cq-lwm-popup"><h3>'+sanitize(displayName(s.name))+'</h3>'+
      '<p>'+(s.city?sanitize(displayName(s.city))+', ':'')+sanitize(s.state)+' &middot; '+sanitize(fmtCompact(s.population))+' served</p>'+
      '<div class="lead-value" style="color:'+t.ink+'">'+sanitize(s.value)+' PPB</div>'+
      '<p style="color:'+t.ink+';font-weight:600">'+sanitize(t.label)+'</p>'+
      '<p style="font-size:12px;color:#6b7280">90th percentile &middot; period ending '+sanitize(fmtPeriod(s.period))+'</p>'+
      '<button type="button" class="cq-lwm-popup-btn" onclick="cqLwmShowSystem(\''+sanitize(s.pwsid)+'\')">View details</button></div>'
    ).openOn(map);
    track('tool_map_dot',{pwsid:s.pwsid,result_value:s.value,result_state:s.state});
  }

  window.cqLwmShowSystem=function(pwsid){
    for(var i=0;i<SYSTEMS.length;i++){
      if(SYSTEMS[i].pwsid===pwsid){
        var s=SYSTEMS[i],zip=s.zips.length?s.zips[0]:'';
        var matches=zip?zipLookupAll(zip):[s];
        lastMatches=matches;lastZip=zip;
        map.closePopup();
        showResults(s,zip,matches,{skipZoom:true,path:'dot'});
        return;
      }
    }
  };

  /* Recommendation ladder, one entry per tier. Product handles, variants,
     and prices verified against the store export 2026-06-10:
       /products/first-draw-flush-dual-lead-test            $85 lead test kit
       /products/lead-under-sink-water-filter-system        $182.90-$256.80 (Triple variant 8648734441586)
       /products/lead-removal-whole-house-water-filter      from $1,631 (6-8 GPM Fiberglass variant 13561635307613)
       /products/reverse-osmosis-under-sink-water-filter    Thunder 1000CP $478.16
       /collections/lead-removal                            commercial-head collection
       /pages/lead-removal-water-filtration-systems         B2B commercial lane */
  var RECS=[
    'No lead was detected in your utility\'s most recent reported sampling round. A non-detect at the system level does not guarantee your tap: lead usually enters water from a building\'s own service line, solder, and brass fixtures. The <a href="/products/first-draw-flush-dual-lead-test" target="_blank" rel="noopener">First Draw &amp; Flush Dual Lead Test</a> confirms what is actually at your faucet, especially in homes built before 1986, when lead solder was banned. If treatment ever makes sense, you can <a href="/collections/lead-removal" target="_blank" rel="noopener">browse all lead removal systems</a> at your own pace.',
    'Trace lead was reported in your area. Because EPA\'s health goal for lead is zero, any detection is worth understanding. Start by confirming your own level with the <a href="/products/first-draw-flush-dual-lead-test" target="_blank" rel="noopener">First Draw &amp; Flush Dual Lead Test</a>. If lead shows up at your tap, a dedicated <a href="/products/lead-under-sink-water-filter-system" target="_blank" rel="noopener">Lead Under Sink Water Filter System</a> (from $182.90) is worth considering for drinking and cooking water. For background, read <a href="/blogs/contaminants/understanding-lead-in-drinking-water" target="_blank" rel="noopener">our complete guide to lead in drinking water</a>.',
    'Elevated lead was reported in your area, approaching the 10 PPB action level that takes effect in 2027. We recommend treating every tap you drink or cook from. The <a href="/products/lead-under-sink-water-filter-system?variant=8648734441586" target="_blank" rel="noopener">Lead Under Sink Water Filter System</a> (Triple, $256.80) uses a dedicated lead and cyst cartridge, with <a href="/products/lead-filter-cartridge" target="_blank" rel="noopener">replacements from $64</a>. If you also want lower TDS, fluoride, and arsenic, the <a href="/products/reverse-osmosis-under-sink-water-filter" target="_blank" rel="noopener">Thunder under-sink reverse osmosis system</a> covers the broad spectrum. <a href="/products/first-draw-flush-dual-lead-test" target="_blank" rel="noopener">Test your own tap</a> to confirm, or <a href="/collections/lead-removal" target="_blank" rel="noopener">browse all lead removal systems</a>.',
    'Your utility\'s reported value exceeds the 10 PPB action level taking effect in 2027, though it is below today\'s 15 PPB level. Treat drinking and cooking water now with a <a href="/products/lead-under-sink-water-filter-system" target="_blank" rel="noopener">Lead Under Sink Water Filter System</a>, and consider the <a href="/products/lead-removal-whole-house-water-filter?variant=13561635307613" target="_blank" rel="noopener">Lead Removal Whole House Water Filter</a> (from $1,631) if your home has pre-1986 plumbing or a lead service line. The <a href="/products/first-draw-flush-dual-lead-test" target="_blank" rel="noopener">First Draw &amp; Flush Dual Lead Test</a> identifies whether the lead comes from a fixture or the service line. Households with children or anyone pregnant should act promptly, per CDC guidance.',
    'Your area has reported lead at or above the current 15 PPB federal action level, which obligates the utility to corrective action. At home you can act now: a <a href="/products/lead-under-sink-water-filter-system" target="_blank" rel="noopener">Lead Under Sink Water Filter System</a> covers drinking and cooking water immediately, and the <a href="/products/lead-removal-whole-house-water-filter?variant=13561635307613" target="_blank" rel="noopener">Lead Removal Whole House Water Filter</a> (from $1,631) covers every tap in homes with lead service lines or pre-1986 plumbing. <a href="/products/first-draw-flush-dual-lead-test" target="_blank" rel="noopener">Test your own tap</a> to find the source, or <a href="/collections/lead-removal" target="_blank" rel="noopener">browse all lead removal systems</a>. For buildings, schools, and businesses, see our <a href="/pages/lead-removal-water-filtration-systems" target="_blank" rel="noopener">commercial lead removal systems</a>.'
  ];

  /* Plain-language tier context appended to the reference strip */
  var EXPLAIN=[
    'A reported 0 means below detection in that sampling round, not lead-free plumbing. Your individual tap can still differ.',
    'About half of U.S. systems report in this range. Because this is a 90th-percentile value, some sampled taps in this system tested higher than the number shown.',
    'This value is higher than what roughly 90% of U.S. systems report. For perspective, 5 PPB is the FDA limit for lead in bottled water.',
    'Only about 1.7% of reporting U.S. systems fall in this band.',
    'A rare and serious result, about 1.5% of reporting systems. An exceedance obligates the utility to corrective action. It is a system-wide trigger, not a measurement of your tap.'
  ];

  function renderReference(value,tier){
    var refEl=document.getElementById('cqLwmReferenceText');
    var html;
    if(value>=15){
      html='<span class="cq-lwm-over">'+sanitize(value)+' PPB</span> is above <span class="cq-lwm-over">both</span> the current 15 PPB federal action level and the 10 PPB level taking effect in 2027. EPA\'s health goal (MCLG) for lead is zero.';
    }else if(value>=10){
      html='<span class="cq-lwm-over">'+sanitize(value)+' PPB</span> is above the 10 PPB action level taking effect in 2027, though below today\'s 15 PPB action level. EPA\'s health goal (MCLG) for lead is zero.';
    }else if(value>0){
      /* 5-10 PPB is the amber "Elevated" tier: the headline number must agree
         with the severity badge, so only sub-5 values keep the green ink. */
      var vOpen=value>=5?'<span style="color:#b45309;font-weight:700">':'<span class="cq-lwm-under">';
      html=vOpen+sanitize(value)+' PPB</span> is below the 10 PPB action level taking effect in 2027. There is no MCL for lead, and EPA\'s health goal (MCLG) is zero: no level of lead exposure is considered safe.';
    }else{
      html='<span class="cq-lwm-under">No lead detected</span> in the most recent reported round. EPA\'s health goal (MCLG) for lead is zero.';
    }
    var idx=TIERS.indexOf(tier);
    if(EXPLAIN[idx])html+=' '+sanitize(EXPLAIN[idx]);
    refEl.innerHTML=html;
  }

  function renderStateContext(code){
    var row=stateRow(code),ct=document.getElementById('cqLwmComparisonText');
    if(!row){ct.innerHTML='';return;}
    ct.innerHTML='<span class="cq-lwm-state">'+sanitize(stateNames[code]||code)+'</span> context: <strong>'+sanitize(row[0].toLocaleString())+'</strong> systems reported since 2016 &middot; median <strong style="color:'+tierFor(row[3]).ink+'">'+sanitize(row[3])+' PPB</strong> &middot; <strong>'+sanitize(row[1])+'</strong> above the current 15 PPB action level &middot; <strong>'+sanitize(row[2])+'</strong> above the 2027 10 PPB level. Reported systems only, not a census; reporting completeness varies by state.';
  }

  function renderVintage(){
    var m=window.leadData.meta;
    document.getElementById('cqLwmVintage').textContent='Data through '+(m.data_through||m.generated)+' · '+m.metric+' · updated quarterly.';
  }

  var lastMatches=[],lastZip='';

  function renderOthers(matches,zip,active){
    var wrap=document.getElementById('cqLwmOthers');
    if(matches.length<2){wrap.hidden=true;return;}
    /* Total count matches the rendered rows (the list includes the active
       system); "largest is shown above" only while that is actually true. */
    document.getElementById('cqLwmOthersTitle').textContent=matches.length+' water systems serve ZIP '+zip+'. '+(active===matches[0]?'The largest is shown above; select':'Select')+' another to view its result.';
    var html='';
    matches.forEach(function(s){
      var t=tierFor(s.value);
      html+='<div class="cq-lwm-sys-item'+(s===active?' is-active':'')+'" data-pwsid="'+sanitize(s.pwsid)+'" role="button" tabindex="0">'+
        '<span class="cq-lwm-sys-dot" style="background:'+t.scale+'"></span>'+
        '<div class="cq-lwm-sys-info"><strong>'+sanitize(displayName(s.name))+'</strong>'+
        '<span>'+sanitize(fmtCompact(s.population))+' people served &middot; PWSID '+sanitize(s.pwsid)+'</span></div>'+
        '<div class="cq-lwm-sys-level"><div class="cq-lwm-sys-value">'+sanitize(s.value)+'</div><div class="cq-lwm-sys-unit">PPB &middot; '+sanitize(t.label)+'</div></div>'+
        '</div>';
    });
    document.getElementById('cqLwmOthersList').innerHTML=html;
    wrap.hidden=false;
  }

  function showResults(s,zip,matches,opts){
    opts=opts||{};
    var tier=tierFor(s.value);
    document.getElementById('cqLwmSystemBody').hidden=false;
    document.getElementById('cqLwmFallbackBody').hidden=true;
    document.getElementById('cqLwmFallbackRec').hidden=true;
    document.getElementById('cqLwmTitle').textContent=displayName(s.name)+(zip?' - ZIP '+zip:'');
    document.getElementById('cqLwmValue').textContent=s.value;
    document.getElementById('cqLwmValueNote').innerHTML='PPB (&micro;g/L) &middot; 90th percentile &middot; period ending '+sanitize(fmtPeriod(s.period));
    document.getElementById('cqLwmMax').textContent=s.maxPpb;
    document.getElementById('cqLwmMaxNote').textContent='PPB · reported '+s.maxYear;
    var ce=document.getElementById('cqLwmClass');
    ce.textContent=tier.label;
    ce.className='cq-lwm-badge '+tier.cls;
    document.getElementById('cqLwmPop').textContent=fmtCompact(s.population);
    document.getElementById('cqLwmPopNote').textContent='people · PWSID '+s.pwsid;
    renderReference(s.value,tier);
    renderStateContext(s.state);
    if(periodYear(s.period)<2016){
      document.getElementById('cqLwmValueNote').innerHTML+='<br><span class="cq-lwm-over">Historical record: treat as dated, not current</span>';
    }
    renderOthers(matches||[],zip,s);
    document.getElementById('cqLwmRecText').innerHTML=RECS[TIERS.indexOf(tier)];
    renderVintage();
    var panel=document.getElementById('cqLwmResults');
    panel.classList.add('active');
    /* Theme header reappears at full height (198px) on any upward scroll;
       clear it so the panel title is never buried. 16px on the normal
       downward path keeps the tight landing. */
    var pTop=panel.getBoundingClientRect().top+window.scrollY;
    window.scrollTo({top:pTop-(pTop<window.scrollY?210:16),behavior:'smooth'});
    if(!opts.skipZoom)zoomToState(s.state);
    track('tool_result',{result_tier:tier.label,result_value:s.value,result_state:s.state,lookup_path:opts.path||'zip'});
  }

  function showStateFallback(code,zip){
    var row=stateRow(code);
    document.getElementById('cqLwmSystemBody').hidden=true;
    var fb=document.getElementById('cqLwmFallbackBody');
    fb.hidden=false;
    document.getElementById('cqLwmFallbackRec').hidden=false;
    document.getElementById('cqLwmTitle').textContent='ZIP '+zip+' - '+(stateNames[code]||code)+' overview';
    var html='We don\'t have a detailed record for a water system serving ZIP <strong>'+sanitize(zip)+'</strong>. Full records cover community systems serving more than 3,300 people (93% of the U.S. population on systems with lead data); your utility is likely smaller, or is not matched to this ZIP in our database.';
    if(row){
      html+='<br><br><span class="cq-lwm-state">'+sanitize(stateNames[code]||code)+'</span> statewide picture: <strong>'+sanitize(row[0].toLocaleString())+'</strong> systems reported since 2016 &middot; median reported lead <strong style="color:'+tierFor(row[3]).ink+'">'+sanitize(row[3])+' PPB</strong> &middot; <strong>'+sanitize(row[1])+'</strong> above the current 15 PPB action level &middot; <strong>'+sanitize(row[2])+'</strong> above the 2027 10 PPB level &middot; '+sanitize(row[4])+'% non-detect.';
    }
    html+='<br><br>Your water supplier\'s annual Consumer Confidence Report (or your state drinking water program) carries the system-specific result.';
    document.getElementById('cqLwmFallbackText').innerHTML=html;
    document.getElementById('cqLwmRecTextFallback').innerHTML='Without a reported value for your system, the reliable path is the <a href="/products/first-draw-flush-dual-lead-test" target="_blank" rel="noopener">First Draw &amp; Flush Dual Lead Test</a> at your own faucet, especially in homes built before 1986, when lead solder was banned. If your test finds lead, a dedicated <a href="/products/lead-under-sink-water-filter-system" target="_blank" rel="noopener">Lead Under Sink Water Filter System</a> treats the tap you drink from, or you can <a href="/collections/lead-removal" target="_blank" rel="noopener">browse all lead removal systems</a>.';
    renderVintage();
    var panel=document.getElementById('cqLwmResults');
    panel.classList.add('active');
    var pTop=panel.getBoundingClientRect().top+window.scrollY;
    window.scrollTo({top:pTop-(pTop<window.scrollY?210:16),behavior:'smooth'});
    zoomToState(code);
    track('tool_result',{result_tier:'state-aggregate',result_state:code,lookup_path:'state-fallback'});
  }

  window.cqLwmSearch=function(){
    showError('');
    var zip=document.getElementById('cqLwmInput').value.trim();
    if(!/^\d{5}$/.test(zip)){showError('Please enter a valid 5-digit zip code.');return;}
    track('tool_search',{search_type:'zip',search_term:zip});
    var matches=zipLookupAll(zip);
    if(matches.length){lastMatches=matches;lastZip=zip;showResults(matches[0],zip,matches);return;}
    var code=zipToState(zip);
    if(code&&stateRow(code)){lastMatches=[];lastZip=zip;showStateFallback(code,zip);return;}
    showError('We couldn\'t match that to a U.S. zip code. Please double-check the number and try again.');
  };

  window.cqLwmLocate=function(){
    showError('');
    if(!navigator.geolocation){showError('Geolocation is not supported by your browser. Please search by zip code.');return;}
    showLoading();
    navigator.geolocation.getCurrentPosition(function(pos){
      fetch('https://nominatim.openstreetmap.org/reverse?format=json&lat='+pos.coords.latitude+'&lon='+pos.coords.longitude+'&addressdetails=1')
        .then(function(r){return r.json()})
        .then(function(d){
          hideLoading();
          var zc=d&&d.address&&d.address.postcode?String(d.address.postcode).slice(0,5):'';
          if(/^\d{5}$/.test(zc)){document.getElementById('cqLwmInput').value=zc;window.cqLwmSearch();}
          else showError('We couldn\'t resolve your location to a zip code. Please search by zip.');
        })
        .catch(function(){hideLoading();showError('Location lookup failed. Please search by zip code.');});
    },function(){hideLoading();showError('Unable to get your location. Please search by zip code.');},{enableHighAccuracy:false,timeout:10000});
  };

  window.cqLwmClose=function(){document.getElementById('cqLwmResults').classList.remove('active');};
  document.getElementById('cqLwmInput').addEventListener('keypress',function(e){if(e.key==='Enter')window.cqLwmSearch();});

  /* Click or keyboard on an "other system" row swaps it into the main panel */
  var othersList=document.getElementById('cqLwmOthersList');
  function onOtherRow(e){
    var item=e.target.closest?e.target.closest('.cq-lwm-sys-item'):null;
    if(!item)return;
    var pwsid=item.getAttribute('data-pwsid');
    for(var i=0;i<lastMatches.length;i++){
      if(lastMatches[i].pwsid===pwsid){showResults(lastMatches[i],lastZip,lastMatches);return;}
    }
  }
  othersList.addEventListener('click',onOtherRow);
  othersList.addEventListener('keydown',function(e){if(e.key==='Enter'||e.key===' '){onOtherRow(e);e.preventDefault();}});

  /* GA4 product-click tracking on recommendation links + next-step cards */
  document.getElementById('cqLwmResults').addEventListener('click',function(e){
    var a=e.target.closest?e.target.closest('a'):null;
    if(!a)return;
    track('tool_product_click',{link_url:a.href,link_text:(a.getAttribute('data-cq-lwm-product')||a.textContent||'').trim().slice(0,80)});
  });

  var rb=L.control({position:'topleft'});
  rb.onAdd=function(){var d=L.DomUtil.create('div','leaflet-bar');d.innerHTML='<a href="#" title="Reset View" style="display:flex;align-items:center;justify-content:center;width:34px;height:34px;background:white;text-decoration:none;color:#171796;font-size:18px;font-weight:bold;border-radius:var(--cq-r-sm)">↺</a>';d.onclick=function(e){e.preventDefault();map.setView([39.8283,-98.5795],4);window.cqLwmClose()};return d};
  rb.addTo(map);
  }
  // Until the map files arrive, the buttons wait under the loading overlay and replay once the map is ready.
  var held=null,loader=null,early=['cqLwmSearch','cqLwmLocate','cqLwmClose','cqLwmToggleStates','cqLwmToggleDots','cqLwmShowSystem'];
  function overlay(on){var o=document.getElementById('cqLwmLoading');if(o)o.classList.toggle('active',on);}
  early.forEach(function(name){window[name]=function(){if(name!=='cqLwmClose'){held=[name,arguments];overlay(true);}if(loader)loader.load();};});
  function ready(){
    if(typeof L==='undefined'){overlay(false);return;}
    run();
    if(held){var h=held;held=null;overlay(false);window[h[0]].apply(null,h[1]);}
  }
  function boot(){
    var input=document.getElementById('cqLwmInput');
    if(input)input.addEventListener('keypress',function(e){if(e.key==='Enter'&&!(loader&&loader.ready))window.cqLwmSearch();});
    if(typeof window.cqMapLoader!=='function'){overlay(false);return;}
    loader=window.cqMapLoader({
      root:document.querySelector('.cq-lwm')||document,
      css:[cqLwmScript.dataset.cqLwmCss],
      js:[cqLwmScript.dataset.cqLwmLeaflet,cqLwmScript.dataset.cqLwmData,cqLwmScript.dataset.cqLwmStates],
      ready:function(){loader.ready=true;ready();},
      fail:function(){overlay(false);}
    });
    if(held)loader.load();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
